import { render, staticRenderFns } from "./DecimalInput.vue?vue&type=template&id=0fec7ad4&"
import script from "./DecimalInput.vue?vue&type=script&lang=js&"
export * from "./DecimalInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports